module.exports = __webpack_public_path__ + "img/img_technology_retail@3x.19577b86.png";